import DefaultLayout from '../../layout/DefaultLayout';
// import Breadcrumb from '../../components/Breadcrumbs/Breadcrumb';
import DocumentSequenceTableSection from '../../components/documentSequence/DocumentSequenceTableSection';
import ToggleSectionLayout from '../../components/ToggleSection/ToggleSectionLayout';
import ActiveDocumentSequencesSection from '../../components/documentSequence/ActiveDocumentSequencesSection';
import BreadcrumbTwo from '../../components/Breadcrumbs/BreadcrumbTwo';

const DocumentSequences = () => {
  return (
    <DefaultLayout>
      {/* <Breadcrumb pageName="Series Autorizadas" /> */}
      <BreadcrumbTwo />


      <ToggleSectionLayout
        labelOne="Listado de Números de Control"
        labelTwo="Números de Control Activos"
        sectionOne={<DocumentSequenceTableSection />}
        sectionTwo={<ActiveDocumentSequencesSection />}
      />
    </DefaultLayout>
  );
};

export default DocumentSequences;
